const shopifyAdminUrl = (shopId: string, path = "") => {
  const storeHandle = shopId.replace(/\.myshopify\.com$/i, "");
  return `https://admin.shopify.com/store/${storeHandle}${path}`;
};

export const openShopifyProduct = (shopId: string, productId: string) => {
  const url = shopifyAdminUrl(shopId, `/products/${productId}`);
  window.open(url, "_blank", "noopener noreferrer");
};

export const openShopifyStore = (shopId: string) => {
  window.open(shopifyAdminUrl(shopId), "_blank", "noopener noreferrer");
};

export const openShopifyShippingSettings = (shopId: string) => {
  const cleanShopId = shopId.replace(/\.myshopify\.com$/, "");
  const url = `https://admin.shopify.com/store/${cleanShopId}/settings/shipping`;
  window.open(url, "_blank", "noopener noreferrer");
};

export const shopifyBillingSettingsUrl = (shopId: string) =>
  shopifyAdminUrl(shopId, "/settings/billing");
